import { consoleWarn } from '@/modules/logging/utils'
import { KeyDict } from '@/types'

export default class RefCounter {
  private _objectRefCount: KeyDict<number> = {}
  private _objectType = ''

  constructor (objectType: string) {
    this._objectType = objectType
  }

  public get (objectId: string|null = '') { return (objectId ? this._objectRefCount[objectId] : 0) ?? 0 }

  public increment (objectId: string|null = '') {
    if (!objectId) {
      consoleWarn(`Cannot increment object reference with nullish ${this._objectType} object key. Ignoring.`)
      return
    }
    const clientCount = this._objectRefCount[objectId] ?? 0
    this._objectRefCount[objectId] = clientCount + 1
  }

  public decrement (objectId: string|null = '') {
    if (!objectId || this._objectRefCount[objectId] === undefined) {
      consoleWarn(`Attempt to decrement reference count for nullish ${this._objectType} object key. Ignoring.`,
        { objectId })
      return
    }
    this._objectRefCount[objectId] = this._objectRefCount[objectId] - 1
  }

  public reset (objectId: string|null = '') {
    if (!objectId) {
      consoleWarn(`Attempt to reset reference count for nullish ${this._objectType} object key. Ignoring.`)
      return
    }
    this._objectRefCount[objectId] = 0
  }
}
